import request from "@/utils/request";

const trackConsent = (params) => request
  .put("/api/consent", {
    body: {
      cookie_consent: { // eslint-disable-line camelcase
        statistics: params.statistics,
        marketing: params.marketing
      }
    },
    token: true
  });

export default {
  trackConsent
};
